import { render, staticRenderFns } from "./frontPropuestaContainer.vue?vue&type=template&id=8a756dd2&"
import script from "./frontPropuestaContainer.vue?vue&type=script&lang=js&"
export * from "./frontPropuestaContainer.vue?vue&type=script&lang=js&"
import style0 from "./frontPropuestaContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports